import { DefaultChip } from '@omnea-app/frontend/components/shared/ui/chip/DefaultChip'

interface Props {
  stage: number
  totalStages: number
  stageLabel: string
}

export const TaskStageChip = ({ stage, totalStages, stageLabel }: Props) => {
  const CURRENTLY_HIDDING_AVATAR_TEXT = true
  // NOTE (Dalyan): Awaiting some design modifications from Jozef, such that
  // currently, we want to hdie the `avatarText`. In the future, remvove
  // the `CURRENTLY_HIDDING_AVATAR_TEXT` variable from this component entirely.
  const avatarText = totalStages > 1 && false ? `${stage} / ${totalStages}` : undefined
  return <DefaultChip label={stageLabel} color="neutral" avatarText={CURRENTLY_HIDDING_AVATAR_TEXT ? undefined : avatarText} />
}
